import * as actions from './app-context.actions';
import { Action, createReducer, on } from '@ngrx/store';

export interface SearchValues {
  rooms: string;
  checkIn: string;
  checkOut: string;
  dates: string;
  currencyCode: string;
  brand: string;
  priceBy: string;
  origin: string;
  withFullPrice: boolean;
  p: string;
}

export interface AppContextState {
  searchValues: SearchValues;
}

const initialState: AppContextState = {
  searchValues: null,
};

const _appContextReducer = createReducer<AppContextState>(
  initialState,

  on(actions.setSearchValues, (state, { params }) => {
    const dates: string[] = (params as any).date
      ? (params as any).date.split(',')
      : ['', ''];
    return {
      ...state,
      searchValues: {
        ...params,
        checkIn: dates[0],
        checkOut: dates[1],
      },
    };
  }),
);

export function appContextReducer(state: AppContextState, action: Action) {
  return _appContextReducer(state, action);
}
